import React from 'react';
import PropTypes from 'prop-types';
import { LoadingSpinner } from './LoadingSpinner';
import {
  StyledLoadingOverlay,
  StyledLoadingOverlayContent,
  StyledLoadingOverlaySpinner,
} from './styles';

export const LoadingOverlay = ({
  className,
  isLoading = false,
  spinnerVariant = 'dark',
  children,
}) => {
  return (
    <StyledLoadingOverlay className={className} data-testid="loading-overlay">
      <StyledLoadingOverlayContent $isLoading={isLoading}>
        {children}
      </StyledLoadingOverlayContent>
      {isLoading && (
        <StyledLoadingOverlaySpinner aria-hidden="true">
          <LoadingSpinner decorative variant={spinnerVariant} />
        </StyledLoadingOverlaySpinner>
      )}
    </StyledLoadingOverlay>
  );
};

LoadingOverlay.displayName = 'LoadingOverlay';

LoadingOverlay.propTypes = {
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  spinnerVariant: PropTypes.oneOf(['light', 'dark']),
  children: PropTypes.node.isRequired,
};
